// extracted by mini-css-extract-plugin
export default {"subHeader":"SortedBuildings_subHeader__9R9lM"};